__turbopack_context__.v({
  "centeredOverlay": "AccountProjectsView-module__iVo52q__centeredOverlay",
  "content": "AccountProjectsView-module__iVo52q__content",
  "emptyState": "AccountProjectsView-module__iVo52q__emptyState",
  "loadMoreSpinner": "AccountProjectsView-module__iVo52q__loadMoreSpinner",
  "searchContainer": "AccountProjectsView-module__iVo52q__searchContainer",
});
